import { InputField, IInputProps } from '@_shared/ui/InputField';
import { Typography } from '@_shared/ui/Typography';

import * as S from './style';

interface IProps {
	children: React.ReactNode;
}

export function Container({ children }: IProps) {
	return <S.Container>{children}</S.Container>;
}

export function Label({ children }: IProps) {
	return (
		<Typography type="title-large" color="font-secondary">
			{children}
		</Typography>
	);
}

export function Input(props: IInputProps) {
	return <InputField {...props} />;
}

export function Explain({ children }: IProps) {
	return (
		<S.Explain type="label-medium" color="font-tertiary">
			{children}
		</S.Explain>
	);
}
